import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './seo_uber.component.html'
})
export class SeoUberModalComponent extends BaseSupportModalComponent {
	siteId: string;
	action: string;

	async ok() {
		if (confirm(`Вы уверены, что хотите ${this.action == 'set' ? 'установить' : 'снять'} SEO-Divly-метку сайту: ${this.title}?`)) {

			await this.supportService.setSEODivlyLabel(this.siteId, this.action, this.comment).toPromise();

			this.execute();
		}
	}
}
